module.exports = __webpack_public_path__ + "media/images/services/packing-8d8072d738bd6ae8c9f8bd7c1b4bf46b.jpg";